import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, lastValueFrom, firstValueFrom } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { datePickerMinDate, emailPattern } from '../../shared/constants';
import { catchError, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../../animations/route-animation';
import { addMonths } from 'date-fns';
import { DomSanitizer } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import { HttpErrorResponse } from '@angular/common/http';
import { NavbarComponent } from '../../navbar/navbar.component';

@Component({
	selector: 'app-closure-report',
	templateUrl: './closure-report.component.html',
	styleUrl: './closure-report.component.scss'
})
export class ClosureReportComponent implements OnInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
			]
		}
	};
	uId: any = null;
	caseDetails: any = {};
	reportDetails: any = null;
	pageLoading1 = false;
	pageLoading2 = false;
	pageLoading3 = false;
	downloadLoader = false;
	pagetitle: string = "Closure Report";
	moduleForm!: FormGroup;
	minDate = datePickerMinDate;
	formSubmitted = false;
	saveLoader = false;
	showReport = false;
	fileURL: any = null;
	doctortList: any = [];

	otpFormLoader = false;
	showOTP = false;
	otpFormSubmitted = false;
	otpForm: FormGroup = this.formBuilder.group({
		reason: [null, [Validators.required]],
		otp: [null]
	});
	get f1() { return this.otpForm.controls }
	customErrorOTP: any = {};
	otpMailId: any = "";
	closure_report_sent = false;
	rep_sent_loader = false;

	constructor(private sanitizer: DomSanitizer, private router: Router, private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		this.resetForm();
	}
	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"];
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/empty", name: "Appointment Details" });
			this.breadcrumbList.push({ path: "/app/closure-report/" + this.uId, name: "Closure Report" });
			this.getCaseDetails();
			this.getClosureReportDetails();
			this.getDoctor();
		});
	}

	resetForm() {
		this.moduleForm = this.formBuilder.group({
			date: [null],
			ref_by: [null],
			ref_by_contact: [null],
			ref_by_email: [null, [Validators.pattern(emailPattern)]],
			poc: [null],
			poc_contact: [null],
			poc_email: [null, [Validators.pattern(emailPattern)]],
			medical_history: [null],
			preliminary_diagnosis: [null],
			closure_notes: [null],
			doctor_1_id: [null, [Validators.required]],
			doctor_2_id: [null, [Validators.required]],
			key_evaluations: this.formBuilder.array([]),
			treatments: this.formBuilder.array([]),
			appointments: this.formBuilder.array([])
		});
	}

	get f() { return this.moduleForm.controls; }

	get get_key_evaluations() {
		return this.moduleForm.controls['key_evaluations'] as FormArray;
	}

	get get_treatments() {
		return this.moduleForm.controls['treatments'] as FormArray;
	}

	get get_appointments() {
		return this.moduleForm.controls['appointments'] as FormArray;
	}

	add_key_evaluations() {
		const form = this.formBuilder.group({
			/* date: [null], */
			evaluation: [null],
			notes: [null]
		});
		this.get_key_evaluations.push(form);
	}

	add_treatments() {
		const form = this.formBuilder.group({
			treating_dr: [{ value: null, disabled: true }],
			specialist: [{ value: null, disabled: true }],
			clinic_name: [{ value: null, disabled: true }],
			city: [{ value: null, disabled: true }]
		});
		this.get_treatments.push(form);
	}

	add_appointments() {
		const form = this.formBuilder.group({
			id: [null],
			follow_up_date: [null],
			opd_notes: [null]
		});
		this.get_appointments.push(form);
	}

	delete_key_evaluations(index: number) {
		this.get_key_evaluations.at(index).markAsUntouched();
		this.get_key_evaluations.at(index).updateValueAndValidity();
		this.get_key_evaluations.removeAt(index);
		this.moduleForm.markAsDirty();
	}

	delete_treatments(index: number) {
		this.get_treatments.at(index).markAsUntouched();
		this.get_treatments.at(index).updateValueAndValidity();
		this.get_treatments.removeAt(index);
		this.moduleForm.markAsDirty();
	}

	delete_appointments(index: number) {
		this.get_appointments.at(index).markAsUntouched();
		this.get_appointments.at(index).updateValueAndValidity();
		this.get_appointments.removeAt(index);
		this.moduleForm.markAsDirty();
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	showErrorKeyEval(index: number, field: string) {
		let f: any = this.get_key_evaluations.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}

	showErrorTreat(index: number, field: string) {
		let f: any = this.get_treatments.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}

	showErrorAppt(index: number, field: string) {
		let f: any = this.get_appointments.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}

	getDoctor() {
		this.apiService.getDoctors({ "type": 1/* User type Doctor */ }).subscribe({
			next: (data: any) => {
				this.doctortList = data.data;
			}, error: (error) => {
				this.doctortList = [];
			},
		});
	}

	getCaseDetails() {
		this.pageLoading1 = true;
		this.apiService.getUpdateCaseDetails({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.caseDetails = data;
				this.closure_report_sent = this.caseDetails.closure_report_sent;
				this.getReportPDF();
			}, error: (error) => {
				this.pageLoading1 = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getClosureReportDetails() {
		this.pageLoading2 = true;
		this.apiService.getClosureReportDetails({ id: atob(this.uId) }).subscribe({
			next: (data: any) => {
				this.pageLoading2 = false;
				this.resetForm();
				this.reportDetails = data;
				this.f.date.setValue(this.apiService.getDateFromDateString(this.reportDetails.basic_details.date));
				this.f.ref_by.setValue(this.reportDetails.basic_details.ref_by);
				this.f.ref_by_contact.setValue(this.reportDetails.basic_details.ref_by_contact);
				this.f.ref_by_email.setValue(this.reportDetails.basic_details.ref_by_email);
				this.f.poc.setValue(this.reportDetails.basic_details.poc);
				this.f.poc_contact.setValue(this.reportDetails.basic_details.poc_contact);
				this.f.poc_email.setValue(this.reportDetails.basic_details.poc_email);
				this.f.medical_history.setValue(this.reportDetails.report.medical_history);
				this.f.preliminary_diagnosis.setValue(this.reportDetails.basic_details.preliminary_diagnosis);
				this.f.closure_notes.setValue(this.reportDetails.report.closure_notes);
				this.f.doctor_1_id.setValue(this.reportDetails.basic_details.doctor_1);
				this.f.doctor_2_id.setValue(this.reportDetails.basic_details.doctor_2);

				let key_evaluations: any = this.reportDetails.report.key_evaluations;
				if (key_evaluations) {
					let len_key_evaluations = key_evaluations.length;
					for (let i = 0; i < len_key_evaluations; i++) {
						this.add_key_evaluations();
						/* this.get_key_evaluations.controls[i].get("date")?.setValue(this.apiService.getDateFromDateString(key_evaluations[i].date)); */
						/* this.get_key_evaluations.controls[i].get("date")?.setValue(key_evaluations[i].date); */
						this.get_key_evaluations.controls[i].get("evaluation")?.setValue(key_evaluations[i].evaluation);
						this.get_key_evaluations.controls[i].get("notes")?.setValue(key_evaluations[i].notes);
					}
				}

				let treatments: any = this.reportDetails.report.treatments;
				if (treatments) {
					let len_treatments = treatments.length;
					for (let i = 0; i < len_treatments; i++) {
						this.add_treatments();
						this.get_treatments.controls[i].get("treating_dr")?.setValue(treatments[i].treating_dr);
						this.get_treatments.controls[i].get("specialist")?.setValue(treatments[i].specialist);
						this.get_treatments.controls[i].get("clinic_name")?.setValue(treatments[i].clinic_name);
						this.get_treatments.controls[i].get("city")?.setValue(treatments[i].city);
					}
				}

				let appointments: any = this.reportDetails.report.appointments;
				if (appointments) {
					let len_appointments = appointments.length;
					for (let i = 0; i < len_appointments; i++) {
						this.add_appointments();
						this.get_appointments.controls[i].get("id")?.setValue(appointments[i].id);
						this.get_appointments.controls[i].get("opd_notes")?.setValue(appointments[i].opd_notes);
						this.get_appointments.controls[i].get("follow_up_date")?.setValue(appointments[i].follow_up_date);
					}
				}
				if (this.navbar.userAccess?.Closure_Report != 'Full') {
					this.moduleForm.disable();
				}
			}, error: (error) => {
				this.pageLoading2 = false;
				this.reportDetails = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	saveClosureReport_A() {
		this.formSubmitted = true;
		if (this.moduleForm.invalid) {
			this.toastr.error("Please check required fields", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const followup = this.getChangedFollowupNotes();
		if (followup.length) {
			this.otpVerification();
		} else {
			this.saveClosureReport_B();
		}
	}

	getChangedFollowupNotes() {
		let followup: any[] = [];
		for (let i = 0; i < this.get_appointments.controls.length; i++) {
			if (this.get_appointments.controls[i].get("opd_notes")?.value !== this.reportDetails.report.appointments[i].opd_notes) {
				followup.push({
					id: this.get_appointments.controls[i].get("id")?.value,
					note: this.get_appointments.controls[i].get("opd_notes")?.value
				})
			}
		}
		return followup;
	}

	saveClosureReport_B() {
		/* let key_evaluations: any = [];
		for (let i = 0; i < this.get_key_evaluations.controls.length; i++) {
			key_evaluations.push({
				notes: this.get_key_evaluations.controls[i].get("notes")?.value,
				evaluation: this.get_key_evaluations.controls[i].get("evaluation")?.value,
				date: this.apiService.getDateStringFromDate(this.get_key_evaluations.controls[i].get("date")?.value)
			});
		} */
		/* let treatments: any = [];
		for (let i = 0; i < this.get_treatments.controls.length; i++) {
			treatments.push({
				treating_dr: this.get_treatments.controls[i].get("treating_dr")?.value,
				specialist: this.get_treatments.controls[i].get("specialist")?.value,
				clinic_name: this.get_treatments.controls[i].get("clinic_name")?.value,
				city: this.get_treatments.controls[i].get("city")?.value,
			});
		} */
		let appointments: any = [];
		for (let i = 0; i < this.get_appointments.controls.length; i++) {
			appointments.push({
				id: this.get_appointments.controls[i].get("id")?.value,
				follow_up_date: this.get_appointments.controls[i].get("follow_up_date")?.value,
				opd_notes: this.get_appointments.controls[i].get("opd_notes")?.value
			});
		}
		let payload = {
			case_id: this.caseDetails.id,
			ref_by: this.f.ref_by.value,
			ref_by_contact: this.f.ref_by_contact.value,
			ref_by_email: this.f.ref_by_email.value,
			poc: this.f.poc.value,
			poc_email: this.f.poc_email.value,
			poc_contact: this.f.poc_contact.value,
			medical_history: this.f.medical_history.value,
			preliminary_diagnosis: this.f.preliminary_diagnosis.value,
			closure_notes: this.f.closure_notes.value,
			doctor_1_id: this.f.doctor_1_id.value,
			doctor_2_id: this.f.doctor_2_id.value,
			date: this.apiService.getDateStringFromDate(this.f.date.value),
			/* key_evaluations: key_evaluations, */
			/* treatments: treatments, */
			appointments: appointments,
		}
		this.saveLoader = true;
		this.apiService.saveClosureReportDetails(payload).subscribe({
			next: (data: any) => {
				this.saveLoader = false;
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getClosureReportDetails();
				this.getReportPDF();
			}, error: (error) => {
				this.saveLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	clearOTPForm() {
		this.otpForm.reset();
		this.showOTP = false;
		this.otpMailId = "";
		this.f1["reason"].enable();
		this.f1["otp"].setValidators(null);
		this.f1["otp"].updateValueAndValidity();
	}

	otpVerification() {
		this.clearOTPForm();
		$("#otpModalReport").modal("show");
	}

	showOTPFormError(field: string) {
		if (this.f1[field].invalid && (this.otpFormSubmitted || this.f1[field].touched || this.f1[field].dirty)) {
			return true;
		}
		return false;
	}

	clearCustomErrorOTP() {
		Object.keys(this.f1).forEach(key => {
			if (this.f1[key].hasError('incorrect')) {
				try {
					delete this.f1[key].errors?.incorrect;
					this.f1[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customErrorOTP = {};
	}

	getOTPPayload() {
		return {
			"case_id": this.caseDetails.id,
			"type": "report",
			"field": "notes",
			"reason": this.f1["reason"].value,
			"followup": this.getChangedFollowupNotes()
		}
	}

	getOTP() {
		this.otpFormSubmitted = true;
		this.clearCustomErrorOTP();
		if (this.otpForm.invalid) {
			this.toastr.error('Please check required parameters', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const payload = this.getOTPPayload();
		this.otpFormLoader = true;
		this.apiService.getOTP(payload).subscribe({
			next: (data: any) => {
				this.otpFormLoader = false;
				this.showOTP = true;
				this.otpMailId = data;
				this.f1["reason"].disable();
				this.f1["otp"].setValidators([Validators.required]);
				this.f1["otp"].updateValueAndValidity();
				this.otpFormSubmitted = false;
				this.toastr.success('OTP sent successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}, error: (error) => {
				this.otpFormLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	verifyOTP() {
		this.otpFormSubmitted = true;
		this.clearCustomErrorOTP();
		if (this.otpForm.invalid) {
			this.toastr.error('Please check required parameters', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const payload = this.getOTPPayload();
		payload["otp"] = this.f1["otp"].value;
		this.otpFormLoader = true;
		this.apiService.verifyOTP(payload).subscribe({
			next: (data: any) => {
				this.otpFormLoader = false;
				this.clearOTPForm();
				this.toastr.success('OTP verified successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				$("#otpModalReport").modal("hide");
				this.saveClosureReport_B();
			}, error: (error) => {
				this.otpFormLoader = false;
				this.f1.otp.setErrors({ incorrect: true });
				this.customErrorOTP.otp = "Invalid OTP";
			}
		});
	}

	downloadReport() {
		Swal.fire({
			title: "Verify Password",
			input: "password",
			inputLabel: "Enter Password",
			inputAttributes: {
				autocapitalize: "off"
			},
			showCancelButton: true,
			confirmButtonText: "Verify",
			showLoaderOnConfirm: true,
			backdrop: true,
			allowOutsideClick: () => !Swal.isLoading(),
			preConfirm: async (password) => {
				try {
					const responseFlag = await firstValueFrom(this.apiService.verifyPassword({ password: password }));
					if (responseFlag) {
						this.toastr.success("Password verified successfully", 'Success', { timeOut: 3000, tapToDismiss: true, closeButton: true });
					} else {
						Swal.showValidationMessage('Invalid Password');
					}
					return responseFlag
				} catch (error) {
					Swal.showValidationMessage('Invalid Password');
					return false;
				}
			}
		}).then((result) => {
			if (result.isConfirmed) {
				this.getReportPDF(true);
			}
		});
	}

	getReportPDF(isDownload = false) {
		if (isDownload) {
			this.downloadLoader = true;
		} else {
			this.pageLoading3 = true;
		}
		this.apiService.closureReportPDF({ "case_id": this.caseDetails.id, "flag": isDownload }).subscribe({
			next: (data: any) => {
				let blob = new Blob([data.body], { type: "application/pdf" });
				if (isDownload) {
					FileSaver.saveAs(blob, this.reportDetails.basic_details.name + ".pdf");
					this.downloadLoader = false;
				} else {
					this.pageLoading3 = false;
					this.showReport = true;
					this.fileURL = this.getSafeUrl(URL.createObjectURL(blob) + "#toolbar=0");
				}

			}, error: (error) => {
				if (isDownload) {
					this.downloadLoader = false;
				} else {
					this.pageLoading3 = false;
					this.showReport = false;
				}
				this.showErrorPopup(error, isDownload);
			}
		});
	}

	showErrorPopup(error: any, isDownload: boolean) {
		if (error.status == 400) {
			let msg = "Please save report details to generate report.";
			if (isDownload) {
				this.toastr.error(msg, 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			} else {
				Swal.fire({ title: "Note", text: msg });
			}
		} else {
			this.toastr.error("Unable to fetch report", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		}
	}

	getSafeUrl(url: any) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url)
	}

	reportSentChange() {
		const by = this.navbar.user?.first_name + " " + this.navbar.user?.last_name;
		const date = this.apiService.getDateStringFromDate(new Date());
		let data = {
			id: this.uId,
			closure_report_sent: this.closure_report_sent,
			closure_report_sent_by: by,
			closure_report_sent_date: date
		}
		this.rep_sent_loader = true;
		this.apiService.updateCaseDetails(data).subscribe({
			next: (data: any) => {
				this.rep_sent_loader = false;
				this.toastr.success('Updated successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.caseDetails.closure_report_sent_by = by;
				this.caseDetails.closure_report_sent_date = date.split("-").reverse().join("-");
			}, error: (error) => {
				this.rep_sent_loader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}
}
